
class Preloader{
    constructor(){
        this._countLoaded = 0;
        this._callback = null;
        this._elements = null;
        this._images = null;
        this._isFontReady = false;
        this._isPreloadComplete = false;
    }

    preload(callback){
        this._callback = callback;

        document.fonts.ready.then(this._onFontReady.bind(this));

        this._elements = Array.from(document.querySelectorAll('.preload'));
        
        this._images = [];
        
        this._elements.forEach((element, index)=>{
            let imageUrl;

            switch(element.tagName){
                case 'IMG': imageUrl = element.src;
                            break;
                case 'DIV': imageUrl = element.style.backgroundImage.replace(/["]+/g, '').slice(4, -1);
                            break;
            }
            
            if(imageUrl != '' && this._images.indexOf(imageUrl) == -1){
                this._images.push(imageUrl);
            }                
        })
        
        if(this._images.length == 0){
            this._isPreloadComplete = true;
            this._complete();
        }else{
            this._images.forEach((image, index)=>{
                let img = new Image();
                img.onload = this._onLoadImage.bind(this);
                img.src = image;
                
                if(img.complete){
                    this._onLoadImage();
                }
            })    
        }
        
    }

    _onLoadImage(e){
        this._countLoaded++;
        
        if(this._countLoaded == this._images.length){
            this._isPreloadComplete = true;
            this._complete();        
        }
    }

    _onFontReady(){
        this._isFontReady = true;
        this._complete();
    }

    _complete(){
        if(this._isPreloadComplete && this._isFontReady){
            this._callback();
        }
    }
}

export default Preloader;